import React from "react";
import classes from "./Tag.module.css";

const Tag = ({ label, color, backgroundColor }) => (
    <span style={{ color, backgroundColor }} className={classes.Tag}>
        {label}
    </span>
);

export default Tag;
